setTimeout(() => {
    let sidebar = $('.single-page-sidebar .sidebar, .home .sidebar-col .sidebar, .category .sidebar-col .sidebar');
    let sidebar_single = $('.single-page-sidebar, .home .sidebar-col, .category .sidebar-col');
    let sidebar_top = sidebar.length > 0 ? sidebar.offset().top : false;
    let navbar_compensation = 124;
    let sidebar_height = 0;
    let sidebar_container = sidebar.children('.sidebar__container');
    [...sidebar_container].forEach(sc => {
        sidebar_height += sc.clientHeight;
    });
    
    // Para o sidebar dos posts carregados no single-post.
    let sidebar_home = "";
    let sidebar_home_single = "";
    let sidebar_home_top = "";
    let sidebar_home_height = "";
    let sidebar_home_container = "";
    if($('.single-page-sidebar').length > 0){
        sidebar_home = $('.sidebar-home .sidebar');
        sidebar_home_single = $('.sidebar-home');
        sidebar_home_top = sidebar_home.offset().top;
        sidebar_home_height = 0;
        sidebar_home_container = sidebar_home.children('.sidebar__container');
        [...sidebar_home_container].forEach(sc => {
            sidebar_home_height += sc.clientHeight;
        });
    }
    
    function fixSidebar(sidebar) {
        sidebar.addClass('sticky');
    }
    
    function unfixSidebar(sidebar) {
        sidebar.removeClass('sticky');
    }

    function scrollEffect() {
        let windowTop = window.pageYOffset;
        if (windowTop >= sidebar_top - navbar_compensation - 10) {
            sidebar_height = sidebar.height();
            if (sidebar_single.height() >= sidebar_height + windowTop - sidebar_top + navbar_compensation) {
                sidebar_single.css('align-items', '');
                fixSidebar(sidebar);
            } else {
                sidebar_single.css("align-items", "flex-end");
                unfixSidebar(sidebar);
            }
        } else {
            sidebar_single.css('align-items', '');
            unfixSidebar(sidebar);
        }
    
        // Para o sidebar dos posts carregados no single-post.
        if($('.single-page-sidebar').length > 0){
            if (windowTop >= sidebar_home_top - navbar_compensation - 10) {
                sidebar_home_height = sidebar_home.height();
                if (sidebar_home_single.height() >= sidebar_home_height + windowTop - sidebar_home_top + navbar_compensation) {
                    sidebar_home_single.css('align-items', '');
                    fixSidebar(sidebar_home);
                } else {
                    sidebar_home_single.css("align-items", "flex-end");
                    unfixSidebar(sidebar_home);
                }
            } else {
                sidebar_home_single.css('align-items', '');
                unfixSidebar(sidebar_home);
            }
        }
    }

    document.addEventListener( 'scroll', function( event ) {
        if (sidebar){
            scrollEffect();
        }
    });
}, 100);